import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import StickyBox from 'react-sticky-box';
import { DefaultSpinner, OverlaySpinner } from '../../../ui/Spinner';
import {  ToastConfirm, ToastError } from '../../../ui/AlertesUi';

import Breadcrumb from '../../in/Breadcrumb';
import HomeSideBar from './HomeSideBar';

//Fetch Urls
import { USER_PROFILE_FETCH, POST_PROFILE } from '../../auth/urlParameters';

//Fetching
import { useSelector, useDispatch } from 'react-redux';
import useAxiosToGet from '../../fetchDatasAxios/FetchGet';
import { UpdateUserProfile } from '../../store/Profile/Dispatchs';
import { AppChangeUserPwd } from '../../store/Resetpassword/Dispatchs';

const UserSettings = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const { account, settings, resetPassword } = useSelector(state => ({
      account: state.sessionAuth,
      settings: state.userSettings,
      resetPassword: state.resetPassword
  }));

    const ArrayProfile = {
        nom: '',
        prenoms:'',
        contact:'',
        profession:'',
        residence:'',
        genre:'',
        date_naissance:''
    }
    const[profile, setProfile] = useState(ArrayProfile)
    const[openLoading, setOpenLoading] = useState(false)
    const [userFile, setUserFile] = useState(null)
    const[confirmAlerte, setConfirmAlerte] = useState(false)
    const[errorAlerte, setErrorAlerte] = useState(false)
    const [currentPassword, setCurrentPassword] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [passwordSubmitPending, setPasswordSubmitPending] = useState(false)
    const prevConfirmLoading = useRef(resetPassword.confirm_loading)
    
    //get user profile from Fetch
    const {isAppLoading, fetchDatas} = useAxiosToGet(USER_PROFILE_FETCH(account.userId, account.sessionId), account.token);
    useEffect(() => {
      if (isAppLoading) return
      const sectionId = location.hash === '#reset-password' ? 'reset-password' : 'profile'
      const frame = requestAnimationFrame(() => {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
      return () => cancelAnimationFrame(frame)
    }, [isAppLoading, location.hash, location.key])
    useEffect(()=>{
        
        if(fetchDatas !== null){
            
            let UserProfile = fetchDatas.data.profile
           
            setProfile({
                ...profile,
                ...UserProfile
            })
           
        }
    // eslint-disable-next-line 
    },[fetchDatas])

     //Alert success
  const AlertSuccess = (alerte) =>{
    if(confirmAlerte === false){
      ToastConfirm(alerte)
      setConfirmAlerte(true)
    }
  }
  //Error Alerte
  const AlertError = alerte =>{
    if(errorAlerte === false){
      ToastError(alerte)
      setErrorAlerte(true)
    }
  }

  const passwordWarning = useMemo(() => {
    if (!newPassword && !confirmPassword) return ''
    if (!currentPassword) {
      return 'Saisissez votre mot de passe actuel.'
    }
    if (newPassword.length > 0 && newPassword.length < 8) {
      return 'Le mot de passe doit contenir au moins 8 caractères.'
    }
    if (confirmPassword && newPassword !== confirmPassword) {
      return 'Les mots de passe ne correspondent pas.'
    }
    return ''
  }, [currentPassword, newPassword, confirmPassword])

  const canSubmitPassword = currentPassword.length > 0
    && newPassword.length >= 8
    && newPassword === confirmPassword
    && !resetPassword.confirm_loading

  useEffect(() => {
    const wasLoading = prevConfirmLoading.current
    if (passwordSubmitPending && wasLoading && !resetPassword.confirm_loading) {
      if (resetPassword.confirm_error) {
        ToastError(resetPassword.error_callback || 'Erreur lors de la mise à jour du mot de passe.')
      } else if (resetPassword.confirm_success) {
        ToastConfirm(resetPassword.success_callback || 'Mot de passe mis à jour.')
        setCurrentPassword('')
        setNewPassword('')
        setConfirmPassword('')
      }
      setPasswordSubmitPending(false)
    }
    prevConfirmLoading.current = resetPassword.confirm_loading
  }, [
    passwordSubmitPending,
    resetPassword.confirm_loading,
    resetPassword.confirm_success,
    resetPassword.confirm_error,
    resetPassword.error_callback,
    resetPassword.success_callback
  ])
  
    //console.log(profile)
    const handleProfileChange = e =>{
        setProfile({
            ...profile,
            [e.target.name]: e.target.value
        })
        
    }
  
    //dispatch update
    const UserUpdateProfile = e =>{
        e.preventDefault();
        setConfirmAlerte(false)
        setErrorAlerte(false)
       // moment(profile.date_naissance).format('DD/MM/YYYY')
        var val = document.getElementById('updateForm')
        const formdata = new FormData(val)
        formdata.append('file', userFile)
        
        //post user profile
        dispatch(UpdateUserProfile(POST_PROFILE(account.userId, account.sessionId), account.token, formdata))
    }

    const handlePasswordSubmit = (e) => {
      e.preventDefault()
      if (!account.sessionId || !account.token) {
        ToastError('Session invalide. Veuillez vous reconnecter.')
        return
      }
      if (!currentPassword) {
        ToastError('Saisissez votre mot de passe actuel.')
        return
      }
      if (!canSubmitPassword) return
      setPasswordSubmitPending(true)
      dispatch(
        AppChangeUserPwd(account.sessionId, account.token, {
          currentpwd: currentPassword,
          newpwd: newPassword,
        })
      )
    }

   // const {ModalShow, ModalHide} = ActiveOverlay(settings.isUploading)
  
    
  return isAppLoading ? DefaultSpinner('Chargement...') : (
    <Fragment>
        <Breadcrumb title='Profil'/>
        <div className="content">
        <div className="container">
        <div className="row">
        <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
        <StickyBox offsetTop={20} offsetBottom={20}>
        <HomeSideBar/>
        </StickyBox>                
        </div>
        {/*application */}
        <div className="col-md-7 col-lg-8 col-xl-9">
        <div className="row">

            {/* Basic Information */}
            
            <div className="card" id="profile" style={{ scrollMarginTop: '24px' }}>
                        <div className="card-body">
                          <h4 className="card-title">Vos informations</h4>
                          <form id="updateForm" onSubmit={UserUpdateProfile}>
                          <div className="row form-row">
                            
                            <div className="col-md-12">
                              <div className="form-group">
                                <div className="change-avatar">
                                 
                                </div>
                              </div>
                            </div>
                            
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Nom d'utilisateur <span className="text-danger">*</span></label>
                                <input name='username' type="text" className="form-control" readOnly 
                                value={account.username || ''}/>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Email <span className="text-danger">*</span></label>
                                <input name='email' type="text" className="form-control" readOnly 
                                value={account.email}/>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Mot de passe <span className="text-danger">*</span></label>
                                <input type="password" className="form-control" readOnly value='mot de passe'/>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Nom <span className="text-danger">*</span></label>
                                <input type="text" name = 'nom' className="form-control" 
                                value={profile.nom}
                                onChange = {handleProfileChange}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Prénoms <span className="text-danger">*</span></label>
                                <input type="text" name='prenoms' className="form-control" 
                                value={profile.prenoms}
                                onChange = {handleProfileChange}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Contact</label>
                                <input type="text" name='contact' className="form-control" 
                                value={profile.contact || 'Tel:'}
                                onChange = {handleProfileChange}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Profession</label>
                                <input type="text" name='profession' className="form-control" 
                                value={profile.profession || ''}
                                onChange = {handleProfileChange}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Résidence</label>
                                <input type="text" name='residence' className="form-control" 
                                value={profile.residence || ''}
                                onChange = {handleProfileChange}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Genre</label>
                                <select name='genre' className="form-control select"
                                onChange = {handleProfileChange} >
                                <option>{profile.genre||'Choix'}</option>
                                  <option>Autres</option>
                                  <option>Homme</option>
                                  <option>Femme</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group mb-0">
                                <label>Année de naissance</label>
                                <input type="date" name='date_naissance' className="form-control" 
                                value={profile.date_naissance||''}
                                onChange = {handleProfileChange}
                                />
                              </div>
                            </div>
                           
                          </div>
                          {/* /Registrations */}
                            <div style={{marginTop:'22px'}} className="submit-section submit-btn-bottom">
                                <button type="submit" className="btn btn-primary submit-btn">Enregistrer les modifications</button>
                                <div className="col-md-10" style={{'marginTop':'20px'}}>
                                {settings.updateSucces && AlertSuccess('Mise à jour éffectuée !')}
                                {settings.updateError && AlertError(settings.callback)}
                               
                                </div>
                            </div>
                          </form>
                        </div>
                      </div>
                      
                      {/* /Basic Information */}

                      <div className="card mt-3" id="reset-password" style={{ scrollMarginTop: '24px' }}>
                        <div className="card-body">
                          <h4 className="card-title">Réinitialiser le mot de passe</h4>
                          <p className="text-muted">
                            Choisissez un nouveau mot de passe pour sécuriser votre compte.
                          </p>
                          <form onSubmit={handlePasswordSubmit}>
                            <div className="row">
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>Mot de passe actuel</label>
                                  <input
                                    type={showPassword ? 'text' : 'password'}
                                    className="form-control"
                                    value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                    autoComplete="current-password"
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>Nouveau mot de passe</label>
                                  <div className="input-group">
                                    <input
                                      type={showPassword ? 'text' : 'password'}
                                      className="form-control"
                                      value={newPassword}
                                      onChange={(e) => setNewPassword(e.target.value)}
                                      autoComplete="new-password"
                                    />
                                    <button
                                      type="button"
                                      className="btn btn-outline-secondary"
                                      onClick={() => setShowPassword((prev) => !prev)}
                                    >
                                      {showPassword ? 'Masquer' : 'Afficher'}
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>Confirmer le mot de passe</label>
                                  <input
                                    type={showPassword ? 'text' : 'password'}
                                    className="form-control"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    autoComplete="new-password"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="d-flex flex-column flex-md-row align-items-md-center gap-2">
                              <small className="text-muted">Minimum 8 caractères.</small>
                              {passwordWarning && <small className="text-danger">{passwordWarning}</small>}
                            </div>
                            <div className="mt-3">
                              <button
                                type="submit"
                                className="btn btn-danger"
                                disabled={!canSubmitPassword}
                              >
                                {resetPassword.confirm_loading ? 'Mise à jour...' : 'Mettre à jour'}
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                     
                <OverlaySpinner ModalShow={settings.isUploading} 
                    ModalHide={()=>setOpenLoading(false)} 
                    txt = {'Enregistrement...'}
                    openLoading={openLoading}/> 

             </div>
        </div>
        </div>
        </div>
        </div>
    </Fragment>
  )
}

export default UserSettings
